import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';

const VerticalCardInfoContainer = styled.div`
  position: absolute;
  margin-left: ${Screen.widthRatio * 6}px;
  top: ${Screen.widthRatio * 264}px;
  width: ${Screen.widthRatio * 200}px;
`;

export default VerticalCardInfoContainer;
